import React, { Component } from 'react'

export default class AbilityToCompeteError extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div className='opacity-overlay ' style={{ 'display': 'block' }}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-5 popup-content">
                            <div>
                                <div className='modal-body'>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h5>Payers - General - The Total Weight of Benefits Sought must equal 100.</h5>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <button type="button" className="form-control" onClick={()=>this.props.abilityToCompeteErrorModal()}>OK</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AbilityToCompete/RateBenefits/AbilityToCompeteError/AbilityToCompeteError.jsx